import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cidentifier(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
 
      <Sides/>
       <Helmet>
 
 <title>identifiers in c++ tutorial For Beginners</title>
 <meta name="description" content="Identifiers in c++tutorial for beginners.Identifier in c++ is a name given to a variable, method.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,Identifiers in c++tutorial for beginners,programming language tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,c++ identifier,identifier,cpp identifiers" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-identifier" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">What are identifiers in C++</h1>
   
    <div className="first">
        <a href="/cpp-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   
    <h2 className="mt-4 mh2">Identifiers Statement in c++:</h2>
    <p className="mt-4 para">1, Identifier in c++ is a name given to a variable method.<br/>
2, Blank space special symbol is not allowed<br/>
3, It must begin with a letters <br/>
4, You only type less than 31 characters long<br/>
5, You don’t use any keyword in the same manner means or Uppercase and lowercase are different Means.
</p>


<h2 className='headings'>Uppercase and Lowercase Example</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">my_name </span>
            {"\n"}
            <span className="qwerty-4">My_Name </span>
              {"\n"} {"\n"}
              <span className="qwerty-11">both means are different </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Rules of Identifier in c++:</h2>
<h3 className="mt-4 mh3">1, Blank space special symbols are<br/></h3>

      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code >{"\n"}
            <span className="qwerty-2">code-exampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">false </span>
            {"\n"}
            <span className="qwerty-2">code.exampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">false </span>
            {"\n"}
            <span className="qwerty-9">code_exampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-7">true </span>
            {"\n"}
            <span className="qwerty-9">codeexampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-7">true </span>
            {"\n"}
            <span className="qwerty-2">code exampler </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">false </span>
            {"\n"}
              {"\n"} 
          </code>
        </pre>
</div>

<h3 className="mt-4 mh3">2, It must begin with letters<br/></h3>




      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-5">Int -2a; </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty-11">wrong </span>
            {"\n"}
            <span className="qwerty-1">Int a2 </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty-11">true </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-9">Int _24a </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty">false </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>


<h3 className="mt-4 ">3, You don’t use any reserved keyword means:<br/></h3>



      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">int if; </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty-11">false </span>
            {"\n"}
            <span className="qwerty-4">int IF; </span>
            <span className="qwerty-3">- </span>
            <span className="qwerty">true </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>


<h3 className="mt-4 mh3">4, You only type less than 31 characters long <br/></h3>



      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-4">int i;</span>
            <span className="qwerty-2"> &#47;&#47; This declare a variable means i is a variable</span>
            {"\n"}
            <span className="qwerty-4">i=4;</span>
            <span className="qwerty-2"> &#47;&#47; This assigns 4 to (i) means assigns value in Variable</span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-first-program">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cidentifier;